import {changePassword} from "../reducers/recordsSlice.ts";
import {Credentials} from "../../credentials/types.ts";
import {
    useAppDispatch,
    useAppSelector
} from "../../../hooks/useTypedReactRedux.ts";
import {CognitoUser} from 'amazon-cognito-identity-js';
import {changePasswordResultSelector} from "../selectors.ts";
import {Account} from "../../accounts/types.ts";
import {cognitoUserSelector} from "../../credentials/selectors.ts";

export const useChangePassword = (account: Account) => {

    const dispatch = useAppDispatch();

    const changePasswordResult = useAppSelector((state) =>
                                                    changePasswordResultSelector(state)
    );

    const cognitoUser = useAppSelector((state) => cognitoUserSelector(state));

    const handleChangePassword = (values: Credentials) => {
        if (!account) {
            console.error('Account is not loaded yet');
            return;
        }
        if (!cognitoUser) {
            console.error('CognitoUser is not available');
            return;
        }
        dispatch(
            changePassword({
                               account,
                               cognitoUser: cognitoUser as CognitoUser,
                               newPassword: values.new_password as string
                           })
        );
    };


    return {
        changePasswordResult,
        handleChangePassword,
    }


}